(function($, window, document, undefined) {
	$.fn.quicksearch = function (target, opt) {
		var timeout, cache, rowcache, jq_results, val = '', e = this, options = $.extend({ 
			delay: 100,
			selector: null,
			stripeRows: null,
			loader: null,
			noResults: '',
			matchedResultsCount: 0,
			bind: 'keyup',
			onBefore: function () { 
				return;
			},
			onAfter: function () { 
				return;
			},
			show: function () {
				this.style.display = "";
			},
			hide: function () {
				this.style.display = "none";
			},
			prepareQuery: function (val) {
				return val.toLowerCase().split(' ');
			},
			testQuery: function (query, txt, _row) {
				for (var i = 0; i < query.length; i += 1) {
					if (txt.indexOf(query[i]) === -1) {
						return false;
					}
				}
				return true;
			}
		}, opt);
		
		this.go = function () {
			
			var i = 0,
				numMatchedRows = 0,
				noresults = true, 
				query = options.prepareQuery(val),
				val_empty = (val.replace(' ', '').length === 0);
			for (var i = 0, len = rowcache.length; i < len; i++) {
				if (val_empty || options.testQuery(query, cache[i], rowcache[i])) {
					options.show.apply(rowcache[i]);
					noresults = false;
					numMatchedRows++;
				} else {
					options.hide.apply(rowcache[i]);
				}
			}
			
			if (noresults) {
				this.results(false);
			} else {
				this.results(true);
				this.stripe();
			}
			
			this.matchedResultsCount = numMatchedRows;
			this.loader(false);
			options.onAfter();
			
			return this;
		};
		
		/*
		 * External API so that users can perform search programatically. 
		 * */
		this.search = function (submittedVal) {
			val = submittedVal;
			e.trigger();
		};
		
		/*
		 * External API to get the number of matched results as seen in 
		 * https://github.com/ruiz107/quicksearch/commit/f78dc440b42d95ce9caed1d087174dd4359982d6
		 * */
		this.currentMatchedResults = function() {
			return this.matchedResultsCount;
		};
		
		this.stripe = function () {
			
			if (typeof options.stripeRows === "object" && options.stripeRows !== null)
			{
				var joined = options.stripeRows.join(' ');
				var stripeRows_length = options.stripeRows.length;
				
				jq_results.not(':hidden').each(function (i) {
					$(this).removeClass(joined).addClass(options.stripeRows[i % stripeRows_length]);
				});
			}
			
			return this;
		};
		
		this.strip_html = function (input) {
			var output = input.replace(new RegExp('<[^<]+\>', 'g'), "");
			output = $.trim(output.toLowerCase());
			return output;
		};
		
		this.results = function (bool) {
			if (typeof options.noResults === "string" && options.noResults !== "") {
				if (bool) {
					$(options.noResults).hide();
				} else {
					$(options.noResults).show();
				}
			}
			return this;
		};
		
		this.loader = function (bool) {
			if (typeof options.loader === "string" && options.loader !== "") {
				 (bool) ? $(options.loader).show() : $(options.loader).hide();
			}
			return this;
		};
		
		this.cache = function () {
			
			jq_results = $(target);
			
			if (typeof options.noResults === "string" && options.noResults !== "") {
				jq_results = jq_results.not(options.noResults);
			}
			
			var t = (typeof options.selector === "string") ? jq_results.find(options.selector) : $(target).not(options.noResults);
			cache = t.map(function () {
				return e.strip_html(this.innerHTML);
			});
			
			rowcache = jq_results.map(function () {
				return this;
			});

			/*
			 * Modified fix for sync-ing "val". 
			 * Original fix https://github.com/michaellwest/quicksearch/commit/4ace4008d079298a01f97f885ba8fa956a9703d1
			 * */
			val = val || this.val() || "";
			
			return this.go();
		};
		
		this.trigger = function () {
			this.loader(true);
			options.onBefore();
			
			window.clearTimeout(timeout);
			timeout = window.setTimeout(function () {
				e.go();
			}, options.delay);
			
			return this;
		};
		
		this.cache();
		this.results(true);
		this.stripe();
		this.loader(false);
		
		return this.each(function () {
			
			/*
			 * Changed from .bind to .on.
			 * */
			$(this).on(options.bind, function () {
				
				val = $(this).val();
				e.trigger();
			});
		});
		
	};


$(document).on('click touch', function(e) {   
	$('.search-results-box').removeClass('active');
});

$(document).ready(function() {  
  $('.kef-faqs, #searcher-results').on('click', 'a[href*="#"]', function(e) {
    $('.search-results-box').removeClass('active');

    var id = $(this).attr('href');
    if (id.indexOf('.') >= 0) {
      id = id.replace('.', '\\.');
    }

		var h = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height').replace('px', ''));
		if ($(window).width() < 1024 && document.body.classList.contains('scroll-btm')) {
			h = parseInt(getComputedStyle(document.body).getPropertyValue('--header-v3-height').replace('px', ''))
		}
		if ($(window).width() < 1024 && Math.ceil($(window).scrollTop()) > pos) {
			h += parseInt(getComputedStyle(document.body).getPropertyValue('--header-announcement-height').replace('px', ''));
		}
    var pos = id == '#top' ? 0 : $(id).offset().top - h - 30;
    
    $('body, html').animate({
      scrollTop: pos
    }, 300);
    
    e.preventDefault();
  });
  
  $('#searcher').quicksearch('.answers .answer', {
    'delay': 500,
    'bind': 'keyup keydown',
    'show': function() {
      if ($('#searcher').val() === '' || $('#searcher').val() === ' ') {
        $('#searcher-results').html('');
        $('.search-results-box').removeClass('active');
        return;
      }      
      $(this).addClass('show');   
  
    },
    'onAfter': function() {
      if ($('#searcher').val() === '' || $('#searcher').val() === ' ') {
        $('.results-count .count').html('');
        $('.results-count .text').html('');
        $('.results-count').removeClass('active');
        $('.noresults-count').removeClass('active');        
        $('#searcher-results').html('');
        $('.show').removeClass('show');
        $('.search-results-box').removeClass('active');
        return;
      }

	    $('#searcher-results').html('');
      $('.show').clone().appendTo("#searcher-results");
      
      var searchText = $('#searcher').val();
      var rx = new RegExp('(?![^<&]+[>;])' + searchText, 'gi');
      
      $('#searcher-results .answer').each(function() {
        $(this).html(function (i, html) {
          return html.replace(rx, '<span class="highlight">$&</span>')
        });

        var id = $('> a', this).attr('id');
        $('> a', this).remove();
        $('> h6', this).wrapInner('<a href="#'+id+'"></a>');
      });
      
      var count = $('#searcher-results > .answer').length; 
      if ($('.show:first').length > 0) {
        $('.results-count .count').html(count);
        $('.results-count .text').html(searchText);
      	$('.results-count').addClass('active');
        $('.noresults-count').removeClass('active');
        $('.search-results-box').addClass('active');
      } else {
      	$('.results-count .count').html('');
        $('.results-count .text').html('');
      	$('.results-count').removeClass('active');
        $('.noresults-count .text').html(searchText);
        $('.noresults-count').addClass('active');
        $('.search-results-box').addClass('active');
      }
    },
    'hide': function() {
      $(this).removeClass('show');
    },
    'prepareQuery': function(val) {
      return new RegExp(val, "i");
      console.log('prepareQuery');
    },
    'testQuery': function(query, txt, _row) {
			return query.test(txt);
      console.log('testQuery');
    }
  });

  $('#searcher').focus();
});
}(jQuery, this, document));
